import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Link } from "react-router-dom";

import { useZoneRetrieval } from "@planzone/view-models";
import { Loader } from "@common/loader";
import { ZoneAvatar } from "@common/zoneAvatar";
import { ContextualMenu } from "./contextualMenu";
import { Props } from "./types";
import { Projects } from "./projects";
import styles from "./styles.scss";

function Zone(props: Props) {
  const { t } = useTranslation();
  const { isRequestPending, isRequestFailure, retrieveZone } =
    useZoneRetrieval();

  React.useEffect(() => {
    retrieveZone(props.zone);
  }, [props.zone.uuid]);

  return (
    <div className={styles.zone}>
      {isRequestPending ? (
        <div className={styles.loader}>
          <div className={styles.loaderMain}>
            <Loader />
          </div>
        </div>
      ) : isRequestFailure ? (
        <div className={styles.loader}>
          <h1 className={styles.title}>{t("zone.error")}</h1>
        </div>
      ) : (
        <div className={styles.main}>
          <div className={styles.header}>
            <div className={styles.heading}>
              <div className={styles.zoneName}>
                <div className={styles.avatar}>
                  <ZoneAvatar {...props.zone} />
                </div>
                <div className={styles.name}>
                  <h1 className={styles.title}>{props.zone.name}</h1>
                  <Link
                    to={`/zones/${props.zone.uuid}/projects`}
                    className={styles.link}
                  >
                    {t("zone.goToZone")}
                  </Link>
                </div>
              </div>
              <ContextualMenu
                edit={() => props.editZone(props.zone)}
                remove={() => props.removeZone(props.zone)}
                transfer={() => props.transferProjects(props.zone)}
              />
            </div>
            <p className={styles.description}>{props.zone.description}</p>
            <div className={styles.tabs}>
              <p className={classNames(styles.tab, styles.selectedTab)}>
                {t("zone.projects")}
              </p>
              <p className={styles.tab}>{t("zone.discussions")}</p>
              <p className={styles.tab}>{t("zone.tasks")}</p>
              <p className={styles.tab}>{t("zone.resources")}</p>
            </div>
          </div>
          <div className={styles.body}>
            <Projects zone={props.zone} />
          </div>
        </div>
      )}
    </div>
  );
}

export { Zone };
